module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Hourglass_16"],"path":[{"$":{"d":"M12,4.09V3h1V1H3V3H4V4.09A3.44,3.44,0,0,0,5.51,6.89L7.07,8,5.51,9.11A3.44,3.44,0,0,0,4,11.91V13H3v2H13V13H12V11.91a3.44,3.44,0,0,0-1.51-2.79L8.93,8l1.56-1.11A3.44,3.44,0,0,0,12,4.09Zm-2,6a2.25,2.25,0,0,1,1,1.82V13H5V11.91a2.25,2.25,0,0,1,1-1.82L8,8.67Zm0-4.18L8,7.33,6,5.91A2.25,2.25,0,0,1,5,4.09V3h6V4.09A2.25,2.25,0,0,1,10,5.91Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Hourglass_16.svg
// module id = jSSN
// module chunks = 1